import { useState, type FocusEvent, type KeyboardEvent } from 'react';

/** Text fields also match :focus-visible after a click. Track navigation intent
 * so pointer editing stays quiet while Tab navigation remains easy to follow. */
export function useSettingsFieldFocus() {
  const [pointerFocus, setPointerFocus] = useState(false);

  function handlePointerDown() { setPointerFocus(true); }
  function handleKeyDown(event: KeyboardEvent<HTMLElement>) {
    if (event.key === 'Tab') setPointerFocus(false);
  }
  function handleBlur(event: FocusEvent<HTMLElement>) {
    if (!event.currentTarget.contains(event.relatedTarget)) setPointerFocus(false);
  }

  return {
    'data-pointer-focus': pointerFocus,
    onPointerDownCapture: handlePointerDown,
    onKeyDownCapture: handleKeyDown,
    onBlurCapture: handleBlur,
  };
}
